import classNames from 'classnames';
import PropTypes from 'prop-types';

import CardMedia from '@mui/material/CardMedia';

import SharedAsset from '../SharedAsset';

import { useStyles } from './index.styles';

const CardImage = ({
  alt = '',
  className,
  src,
  tag = 'figure',
  width = 256
}) => {
  const classes = useStyles();
  /**
   * NOTE: Quick fix for discrpencies between ZD and ZL image components and how data is passed.
   * - ZenDash SharedAsset src needs a '/' at the begining.
   * - ZenLibrary ResponsiveImage src does not use a '/' at the begining.
   */
  const formatedSrc = (typeof src === 'string' && src[0] === '/') ? src : `/${src}`;

  return (
    <CardMedia
      className={classNames(classes.card__image, className)}
      component={tag}
      data-testid="card-image"
    >
      <SharedAsset src={formatedSrc} alt={alt} width={width} />
    </CardMedia>
  );
};

CardImage.propTypes = {
  /** Alt text for image. */
  alt: PropTypes.string,
  /** Override or extend the styles applied to the component. */
  className: PropTypes.string,
  /** Path to shared asset image path. */
  src: PropTypes.string.isRequired,
  /** Change the wrapping elements tag. */
  tag: PropTypes.elementType,
  /** Width of image. */
  width: PropTypes.number
};

export default CardImage;
